import t from "react";
import { I as a } from "./Icon-BZlU65ZH.es.js";
import './IconButton2.css';const i = "IconButton-module__iconButtonContainer___gvUzr", r = {
  iconButtonContainer: i
}, s = ({
  /** the icon name from the set in mintel-icons */
  name: o,
  /** callback when the button is clicked */
  onClick: n,
  /** if true, will render `selected` styles (a yellow fill in the icon) */
  selected: e,
  /** label for accessibility and tooltip */
  label: c
}) => /* @__PURE__ */ t.createElement("div", { className: r.iconButtonContainer }, /* @__PURE__ */ t.createElement(
  a,
  {
    name: o,
    onClick: n,
    selected: e,
    label: c,
    tooltipPlacement: "left"
  }
));
export {
  s as I
};
